import React from 'react';
import Text from '../../styled/Text';
import Distance from '../../styled/Distance';
import ItemPanelItem from './ItemPanelItem';
import { IItemBase, ItemId } from './types';

interface IFeaturedItemsProps<TId extends ItemId, TItem extends IItemBase<TId>> {
  items: TItem[];
  onSelect: (id: TId) => void;
  renderStatus?: (item: TItem) => JSX.Element;
  disableBubbling?: boolean;
  selectableQuery?: (item: TItem) => boolean;
  selectedItem: TItem;
  labels?: { featured: string; general: string };
}

const FeaturedItems = <TItemId extends ItemId, TItem extends IItemBase<TItemId>>({
  selectedItem,
  onSelect,
  items,
  renderStatus,
  selectableQuery,
  disableBubbling,
  labels,
}: IFeaturedItemsProps<TItemId, TItem>) => {
  return (
    <>
      <>
        {labels?.featured && (
          <Text weight="medium" size={['standard', 'large']}>
            {labels.featured}
          </Text>
        )}
        <Distance size="3" />
        <ItemPanelItem
          active={true}
          item={selectedItem}
          onSelect={onSelect}
          renderStatus={renderStatus}
          disableBubbling={disableBubbling}
        />
        {items.map((featuredItem) => (
          <ItemPanelItem
            key={featuredItem.id}
            active={false}
            item={featuredItem}
            onSelect={onSelect}
            renderStatus={renderStatus}
            disableBubbling={disableBubbling}
            selectable={selectableQuery ? selectableQuery(featuredItem) : true}
          />
        ))}
        <Distance size="3" line />
      </>
      <Distance size={['7', '8']} />
      {labels?.general && (
        <Text weight="medium" size={['standard', 'large']}>
          {labels.general}
        </Text>
      )}
      <Distance size="3" />
    </>
  );
};

export default FeaturedItems;
